
import Vue from 'vue'
// 清空对象里的内容,出入对象，返回空对象
export function emptyObject (obj) {
  for (var key in obj) {
    Vue.delete(obj, key)
  }
}
export function deleteParams (obj) {
  for (let key in obj) {
    if (obj[key] === null || obj[key] === '') {
      Vue.delete(obj, key)
    }
  }
}
